import React, { useEffect } from 'react';
declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}
type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: unknown;
  loaded: boolean;
  version: string;
};
const PIXEL_ID = '26302402029436087';
const META_SCRIPT_ID = 'meta-pixel-script';
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
export function MetaPixel() {
  useEffect(() => {
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args);
        } else {
          fbq.queue.push(args);
        }
      } as FbqFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      if (!document.getElementById(META_SCRIPT_ID)) {
        const script = document.createElement('script');
        script.id = META_SCRIPT_ID;
        script.async = true;
        script.src = SCRIPT_SRC;
        const first = document.getElementsByTagName('script')[0];
        if (first && first.parentNode) {
          first.parentNode.insertBefore(script, first);
        } else {
          document.head.appendChild(script);
        }
      }
      window.fbq('init', PIXEL_ID);
    }
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-104" data-mp="1rdko574tw2mh">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-105" data-mp="1rdb5k4m44xqt" />
    </noscript>;
}